/**
 * Main navigation (nav-1): desktop pulldowns + mobile panel/accordion.
 */
(function () {
	const nav = document.querySelector('.main-navigation--nav-1');
	if (!nav) return;

	const burger = nav.querySelector('.main-navigation__open');
	const panel = nav.querySelector('#main-navigation__panel');

	function getMobileMaxWidth() {
		const switchPx = parseInt(getComputedStyle(nav).getPropertyValue('--mobilemenu-switch'), 10);
		return Number.isFinite(switchPx) && switchPx > 0 ? switchPx - 1 : 959;
	}

	function isMobileNav() {
		return window.matchMedia(`(max-width: ${getMobileMaxWidth()}px)`).matches;
	}

	function syncNavLayoutClass() {
		document.documentElement.classList.toggle('nav-is-mobile', isMobileNav());
	}

	function syncPanelAriaHidden() {
		if (!panel) return;

		if (!isMobileNav()) {
			panel.removeAttribute('aria-hidden');
			return;
		}

		panel.setAttribute('aria-hidden', nav.classList.contains('is-open') ? 'false' : 'true');
	}

	let lockedScrollY = 0;

	function setScrollLock(locked) {
		const root = document.documentElement;
		const isLocked = root.classList.contains('main-navigation-lock');

		if (locked === isLocked) return;

		root.classList.toggle('main-navigation-lock', locked);

		if (locked) {
			lockedScrollY = window.scrollY || window.pageYOffset || 0;
			const scrollbarWidth = window.innerWidth - root.clientWidth;
			document.body.style.position = 'fixed';
			document.body.style.top = `-${lockedScrollY}px`;
			document.body.style.left = '0';
			document.body.style.right = '0';
			document.body.style.width = '100%';
			if (scrollbarWidth > 0) {
				document.body.style.paddingRight = `${scrollbarWidth}px`;
			}
			return;
		}

		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.left = '';
		document.body.style.right = '';
		document.body.style.width = '';
		document.body.style.paddingRight = '';
		window.scrollTo(0, lockedScrollY);
	}

	function setPanelOpen(open) {
		if (!burger || !panel || !isMobileNav()) return;

		nav.classList.toggle('is-open', open);
		setScrollLock(open);
		burger.setAttribute('aria-expanded', String(open));
		burger.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
		syncPanelAriaHidden();

		if (!open) {
			nav.querySelectorAll('.main-navigation__item--has-children.is-submenu-open').forEach((item) => {
				setSubmenuOpen(item, false);
			});
		}
	}

	if (burger && panel) {
		burger.addEventListener('click', () => {
			setPanelOpen(!nav.classList.contains('is-open'));
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && nav.classList.contains('is-open')) {
				setPanelOpen(false);
			}
		});

		panel.addEventListener('click', (e) => {
			if (e.target.closest('a')) {
				setPanelOpen(false);
			}
		});

		window.addEventListener('resize', () => {
			if (!isMobileNav()) {
				setPanelOpen(false);
				nav.classList.remove('is-open');
				setScrollLock(false);
				burger.setAttribute('aria-expanded', 'false');
				burger.setAttribute('aria-label', 'Menü öffnen');
			}
			syncPanelAriaHidden();
		});

		syncPanelAriaHidden();
	}

	const mobileMql = window.matchMedia(`(max-width: ${getMobileMaxWidth()}px)`);
	const onBreakpointChange = () => {
		syncNavLayoutClass();
	};
	if (typeof mobileMql.addEventListener === 'function') {
		mobileMql.addEventListener('change', onBreakpointChange);
	} else if (typeof mobileMql.addListener === 'function') {
		mobileMql.addListener(onBreakpointChange);
	}
	syncNavLayoutClass();

	function submenuToggles(item) {
		return item.querySelectorAll('.main-navigation__subtoggle, .main-navigation__item-row > .main-navigation__link');
	}

	function setSubmenuOpen(item, open) {
		item.classList.toggle('is-submenu-open', open);
		submenuToggles(item).forEach((el) => {
			el.setAttribute('aria-expanded', String(open));
		});
	}

	nav.querySelectorAll('.main-navigation__item--has-children').forEach((item) => {
		submenuToggles(item).forEach((toggle) => {
			toggle.addEventListener('click', () => {
				setSubmenuOpen(item, !item.classList.contains('is-submenu-open'));
			});
		});
	});
})();
